export const APPLE_MUSIC_NO_SUBSCRIPTION_CODE = "NO_SUBSCRIPTION";
export const APPLE_MUSIC_TEMPORARY_CODE = "APPLE_UPSTREAM_TEMPORARY";

function asRecord(value) {
  if (!value || typeof value !== "object") return {};
  return value;
}

function isTestFlightAppEnv(appEnv = process.env.NEXT_PUBLIC_APP_ENV) {
  return (
    typeof appEnv === "string" &&
    appEnv.trim().toLowerCase() === "testflight"
  );
}

function diagnosticsSuffix(
  code,
  correlationId,
  nodeEnv = process.env.NODE_ENV,
  appEnv = process.env.NEXT_PUBLIC_APP_ENV
) {
  if (nodeEnv === "production" && !isTestFlightAppEnv(appEnv)) return "";

  const details = [];
  if (
    isTestFlightAppEnv(appEnv) &&
    typeof code === "string" &&
    code.trim()
  ) {
    details.push(`code ${code.trim()}`);
  }
  if (typeof correlationId === "string" && correlationId.trim()) {
    details.push(`ref ${correlationId.trim()}`);
  }

  return details.length > 0 ? ` (${details.join(", ")})` : "";
}

/**
 * @param {string | null | undefined} correlationId
 * @param {string | undefined} [nodeEnv]
 * @param {string | undefined} [appEnv]
 */
export function correlationSuffix(
  correlationId,
  nodeEnv = process.env.NODE_ENV,
  appEnv = process.env.NEXT_PUBLIC_APP_ENV
) {
  return diagnosticsSuffix(null, correlationId, nodeEnv, appEnv);
}

/**
 * @param {string | null} code
 * @param {boolean} retryable
 * @returns {"error" | "warn" | "info"}
 */
export function getAppleMusicErrorTone(code, retryable) {
  if (code === APPLE_MUSIC_NO_SUBSCRIPTION_CODE) return "warn";
  if (retryable) return "info";
  return "error";
}

/**
 * @param {unknown} payload
 * @param {number} status
 * @param {string | undefined} [nodeEnv]
 * @param {string | undefined} [appEnv]
 */
export function getAppleMusicSessionErrorState(
  payload,
  status,
  nodeEnv = process.env.NODE_ENV,
  appEnv = process.env.NEXT_PUBLIC_APP_ENV
) {
  const parsed = asRecord(payload);
  const code =
    typeof parsed.code === "string" && parsed.code.trim()
      ? parsed.code.trim()
      : null;
  const correlationId =
    typeof parsed.correlationId === "string" && parsed.correlationId.trim()
      ? parsed.correlationId.trim()
      : null;
  const retryable =
    typeof parsed.retryable === "boolean"
      ? parsed.retryable
      : code !== APPLE_MUSIC_NO_SUBSCRIPTION_CODE;
  const message =
    typeof parsed.error === "string" && parsed.error.trim()
      ? parsed.error.trim()
      : `Apple Music sign-in failed (${status})`;

  return {
    message: `${message}${diagnosticsSuffix(
      code,
      correlationId,
      nodeEnv,
      appEnv
    )}`,
    code,
    correlationId,
    retryable,
    tone: getAppleMusicErrorTone(code, retryable),
  };
}
